export const SignUpWizardKeys = {
  signupToken: "/payments/confirm/:token",
  generalInfo: "/payments/wizard",
  invoiceInfo: "/payments/wizard/invoice-info",
  shippingInfo: "/payments/wizard/shipping-info",
  childrenInfo: "/payments/wizard/association-info",
};

const BlankRedirectRegister = () =>
  import("@/features/auth/presentation/views/BlankRedirectView.vue");

const WzLayoutRoute = () =>
  import("../features/auth/presentation/signup_wizard/views/WizardLayout.vue");
const WzPersonalInfoRoute = () =>
  import(
    "../features/auth/presentation/signup_wizard/views/WizardPersonalInfo.vue"
  );
const WzInvoiceInfoRoute = () =>
  import(
    "../features/auth/presentation/signup_wizard/views/WizardInvoiceInfo.vue"
  );
const WzShippingInfoRoute = () =>
  import(
    "../features/auth/presentation/signup_wizard/views/WizardShippingInfo.vue"
  );
const WzChildrenInfoRoute = () =>
  import(
    "../features/auth/presentation/signup_wizard/views/WizardChildrenInfo.vue"
  );

export const signUpWizardRoutes = [
  {
    path: SignUpWizardKeys.signupToken,
    component: BlankRedirectRegister,
  },
  {
    path: SignUpWizardKeys.generalInfo,
    component: WzLayoutRoute,
    children: [
      { path: "/", component: WzPersonalInfoRoute, name: "WizardGeneralInfo" },
      {
        path: SignUpWizardKeys.invoiceInfo,
        component: WzInvoiceInfoRoute,
        name: "WizardInvoiceInfo",
      },
      {
        path: SignUpWizardKeys.shippingInfo,
        component: WzShippingInfoRoute,
        name: "WizardShippingInfo",
      },
      {
        path: SignUpWizardKeys.childrenInfo,
        component: WzChildrenInfoRoute,
        name: "WizardChildrenInfo",
      },
    ],
  },
];
